module.exports = __webpack_public_path__ + "img/jiaot2.b365a9d6.png";